module.exports = __webpack_public_path__ + "0a6f1113a5f5cf35677b4aed69f0844b.jpg";